export default class ComandoAPI {
    constructor() {
        this.servicio = null;
    }

    ejecutar() {
        //implementar
    }

    cancelar() {
        //Puede reemplazarse en un Presentador si se necesita respuestas en la interfaz al cancelar
        if (this.servicio) {
            this.servicio.cancelar();
        }
    }
}
